import { createBasicSelector } from 'util/redux'
import { selectBase } from './selectBase'

export const selectRulesTotal = createBasicSelector(
  selectBase,
  rules => rules.totalCount
)
